export default class Auth {}
